import { Dialog, DialogActions, DialogContent, DialogTitle, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router";
import { useStockControlStore } from "../../hooks/useStockControlStore";

export const DialogCancelar = () => {
  const navigate = useNavigate();
  const { cancelarDialogOpen, closeCancelarDialog } = useStockControlStore();

  return (
    <Dialog open={cancelarDialogOpen} onClose={closeCancelarDialog}>
      <DialogTitle>Control de stock</DialogTitle>
      <DialogContent>
        <Typography>¿Seguro de cancelar la operación?</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={closeCancelarDialog} color="primary">
          Cancelar
        </Button>
        <Button
          onClick={() => {
            closeCancelarDialog();
            navigate(-1);
          }}
          color="primary"
        >
          Aceptar
        </Button>
      </DialogActions>
    </Dialog>
  );
};
